export default __webpack_public_path__ + "static/media/p4.bbf0a19f.png";